import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { PageHeader } from "@/components/common";

export default function AuditPage() {
  const [rows, setRows] = useState([]);
  useEffect(() => { api.get("/admin/audit").then(r => setRows(r.data)); }, []);
  return (
    <>
      <PageHeader title="Audit Log" subtitle="Derived event log across RFQs, orders and verifications." />
      <div className="card">
        <table className="data">
          <thead><tr><th>At</th><th>Event</th><th>Actor</th><th>Target</th><th>Detail</th></tr></thead>
          <tbody>
            {rows.map((e, i) => (
              <tr key={i}>
                <td className="font-mono" style={{ color: "var(--ink-mute)", fontSize: 12, whiteSpace: "nowrap" }}>{e.at ? new Date(e.at).toLocaleString() : "—"}</td>
                <td><span className="pill" style={{ borderColor: "var(--line)", color: "var(--amber-400)" }}>{e.kind}</span></td>
                <td className="font-mono" style={{ color: "var(--ink-mute)", fontSize: 11 }}>{(e.actor || "").slice(0, 10)}</td>
                <td>{e.target}</td>
                <td style={{ color: "var(--ink-dim)", fontSize: 13 }}>{e.detail}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </>
  );
}
